export enum MUTATION_KEYS {
  CREATE_DOCUMENT = 'CREATE_DOCUMENT',
  REORDER_DOCUMENT = 'REORDER_DOCUMENT',
  UPDATE_DOCUMENT = 'UPDATE_DOCUMENT',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
}

export default MUTATION_KEYS
